module.exports = __webpack_public_path__ + "static/media/BookingConfirmLogo.68a8b9b4.png";